import useGet, { UseGetOptions } from '@/service-library/core-hooks/useGet'
import { getDetail } from '@/service-library/request-wrappers'

type UseForeignKeyDetailEndpointProps<T> = {
  url: string
  id: string
  enabled?: boolean
} & Omit<UseGetOptions<T>, 'queryKey'>

export default function useForeignKeyDetailEndpoint<T>({
  url = '',
  id,
  enabled,
  filters,
  ...rest
}: UseForeignKeyDetailEndpointProps<T>) {
  const query = useGet({
    filters,
    queryKey: [url, id, filters],
    serviceFn: (serviceFnOptions) => {
      return getDetail<T>({
        url: `${url}/${id}`,
        ...serviceFnOptions,
      })
    },
    enabled: !!(enabled && url),
    ...rest,
  })

  return query
}
